module.exports = __webpack_public_path__ + "static/img/22340044.01698794.png";